/* Mublio fotolink (3 nov 2026): link naar een specifieke foto in de productgalerij.
   - De URL krijgt ?media=<media-id> van de foto die in beeld is en wordt bijgewerkt bij elk wisselen/swipen.
     Bij de eerste foto (de render) gaat de parameter er weer af.
   - Bij het openen van een link met ?media=<id> springt de galerij direct naar die foto (als die bij de variant hoort).
   Geladen vanuit snippets/product-media-gallery-content.liquid. Alleen de hoofdgalerij van de productpagina. */
(() => {
  const PARAM = 'media';
  const SEL = '.product-information__grid media-gallery slideshow-component';
  let opened = false;
  let timer = null;

  const gallery = () => document.querySelector(SEL);
  const slidesOf = (sc) => [...sc.querySelectorAll('slideshow-slide')].filter((s) => !s.closest('slideshow-component') || s.closest('slideshow-component') === sc);
  const idOf = (slide) => slide && slide.querySelector('[data-media-id]') && slide.querySelector('[data-media-id]').getAttribute('data-media-id');

  function writeUrl() {
    const sc = gallery();
    if (!sc) return;
    const slides = slidesOf(sc);
    const active = slides.find((s) => s.getAttribute('aria-hidden') === 'false');
    if (!active) return;
    const url = new URL(location.href);
    const index = slides.indexOf(active);
    const id = idOf(active);
    if (index <= 0 || !id) url.searchParams.delete(PARAM);
    else url.searchParams.set(PARAM, id);
    if (url.href !== location.href) history.replaceState(history.state, '', url.href);
  }

  function schedule() {
    if (!opened) return;
    clearTimeout(timer);
    timer = setTimeout(writeUrl, 150);
  }

  async function openFromUrl() {
    const want = new URL(location.href).searchParams.get(PARAM);
    const sc = gallery();
    if (want && sc) {
      await customElements.whenDefined('slideshow-component');
      const index = slidesOf(sc).findIndex((s) => idOf(s) === want);
      if (index > 0) {
        const go = async () => { try { await sc.select(index, undefined, { animate: false }); } catch (e) { /* galerij nog niet klaar */ } };
        await go();
        // De slideshow is bij het eerste moment nog niet altijd klaar met de opmaak: na het laden nog een keer
        await new Promise((resolve) => {
          const later = () => setTimeout(async () => { await go(); resolve(); }, 150);
          if (document.readyState === 'complete') later();
          else window.addEventListener('load', later, { once: true });
        });
      }
    }
    opened = true;
  }

  // Wisselen van foto (pijlen, stippen, miniaturen, swipen) en het opnieuw opbouwen van de galerij bij een andere variant
  new MutationObserver((records) => {
    for (const r of records) {
      const t = r.target;
      if (t.nodeType === 1 && t.closest && t.closest(SEL)) { schedule(); return; }
    }
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['aria-hidden'], childList: true });

  // Pijltjestoetsen links/rechts: vorige/volgende foto (niet tijdens typen, niet als de zoomweergave open is; die heeft eigen toetsen)
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    if (e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
    const t = e.target;
    if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
    if (document.querySelector('dialog[open]')) return;
    const sc = gallery();
    if (!sc || typeof sc.next !== 'function') return;
    // Alleen als de galerij (deels) in beeld is
    const r = sc.getBoundingClientRect();
    if (r.bottom < 0 || r.top > window.innerHeight) return;
    // Geen pijltjes binnen een andere slideshow of keuzelijst die zelf op de toetsen reageert
    if (t && t.closest && t.closest('slideshow-component') && t.closest('slideshow-component') !== sc) return;
    if (t && t.closest && t.closest('[role="radiogroup"], fieldset')) return;
    e.preventDefault();
    if (e.key === 'ArrowRight') sc.next(); else sc.previous();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openFromUrl);
  else openFromUrl();
})();
